<template>
  <article>
    <!-- fido 간편인증 변경/해제 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <!--
      MLGI-07-01-03-01 : 간편 인증 번호
    -->
    <modal-pop
      :opened.sync="$store.state.auth.manageFido.fidoPop.pincodeChg.isOpen"
      :modal-header="true"
      :modal-footer="true"
      :btn-close="true"
      title="MLGI-07-01-03-01"
      class="modal"
    >
      <template #content>
        <div>
          <p v-html="$t('MLGI-07-01-03-02')"></p>
          <!-- {{ /*간편 인증 번호를 <br />변경 또는 해제 하시겠습니까?*/ $t("MLGI-07-01-03-02") }} -->
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="FN001">{{ /*인증 번호 변경*/ $t("MLGI-07-01-03-03") }}</button>
        <button class="btn bottom positive" @click="FN002">{{ /*간편 인증 해제*/ $t("MLGI-07-01-03-04") }}</button>
      </template>
    </modal-pop>

    <!-- fido 간편인증 해제 확인 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <!--
      MLGI-07-01-04-01 : 간편 인증 해제
    -->
    <modal-pop
      :opened.sync="$store.state.auth.manageFido.fidoPop.pincodeConfirm.isOpen"
      :modal-header="true"
      :modal-footer="true"
      :btn-close="true"
      title="MLGI-07-01-04-01"
      class="modal"
    >
      <template #content>
        <div>
          <p v-html="$t('MLGI-07-01-04-02')"></p>
          <!-- {{ /*간편 인증 번호를 해제하면 지문 또는 Face ID를 <br />이용한 로그인도 함께 해제 됩니다.<br />계속하시겠습니까?*/ $t("MLGI-07-01-04-02") }} -->
        </div>
      </template>
      <template #footer>
        <button class="btn bottom negative" @click="FN003">{{ /*아니오*/ $t("MCOM-0000005") }}</button>
        <button class="btn bottom positive" @click="FN004">{{ /*예*/ $t("MCOM-0000006") }}</button>
      </template>
    </modal-pop>

    <!-- fido 지문(FaceID)인증 해제 확인 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <!--
      "MLGI-07-01-04-05": "지문 인증 해제"
      "MLGI-07-01-04-09": "Face ID 인증 해제"
    -->
    <modal-pop
      :opened.sync="$store.state.auth.manageFido.fidoPop.fingerprintConfirm.isOpen"
      :modal-header="true"
      :modal-footer="true"
      :btn-close="true"
      :title="$store.state.native.biometryTypeIos === 'faceId' ? 'MLGI-07-01-04-09' : 'MLGI-07-01-04-05'"
      class="modal"
    >
      <template #content>
        <div>
          <!--
          "MLGI-07-01-04-06": "지문 인증을 해제합니다.<br />계속 하시겠습니까?",
          "MLGI-07-01-04-10": "Face ID를 해제합니다.<br />계속하시겠습니까?",
          -->
          <p
            v-html="$t($store.state.native.biometryTypeIos === 'faceId' ? 'MLGI-07-01-04-10' : 'MLGI-07-01-04-06')"
          ></p>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom negative" @click="FN005">{{ /*아니오*/ $t("MCOM-0000005") }}</button>
        <button class="btn bottom positive" @click="FN006">{{ /*예*/ $t("MCOM-0000006") }}</button>
      </template>
    </modal-pop>
  </article>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";

export default {
  created() {},
  mounted() {},
  updated() {},
  data() {
    return {};
  },
  computed: {
    ...mapFields(["menuOpen", "menu", "sessionInfo"]),
    ...mapGetters("auth/manageFido", []),
  },
  methods: {
    ...mapActions("auth/manageFido", ["act001_manageFido"]),
    /**
     * 인증번호 변경버튼 클릭시(단순변경)..
     */
    FN001: function () {
      this.$store._mutations["auth/manageFido/mut001_manageFido"][0]("allclose");
      this.menuOpen = false;
      this.$router.push({ name: "createFidoPincodeStep3" });
      return;
    },
    /**
     * 간편 인증 해제 버튼 클릭시..
     */
    FN002: function () {
      this.$store._mutations["auth/manageFido/mut001_manageFido"][0]("pincodeConfirm");
    },
    /**
     * 간편인증해제 아니오 클릭시..
     */
    FN003: function () {
      this.$store._mutations["auth/manageFido/mut001_manageFido"][0]("allclose");
    },
    /**
     * 간편인증해제 예 클릭시..
     */
    FN004: function () {
      this.$log.info("간편인증번호 해제 시작!!");

      const param = {
        device: this.$store.state.native.smphMchtlUniqNo,
        smphMdelName: this.$store.state.native.smphMdelName,
        bioType: "PINCODE",
      };
      this.$store.dispatch("auth/manageFido/act001_manageFido", param);
    },
    /**
     * 지문인증해제 아니오 클릭시..
     */
    FN005: function () {
      this.$store._mutations["auth/manageFido/mut001_manageFido"][0]("allclose");
    },
    /**
     * 지문인증해제 예 클릭시..
     */
    FN006: function () {
      this.$log.info("지문인증 해제 시작!!");

      const param = {
        device: this.$store.state.native.smphMchtlUniqNo,
        smphMdelName: this.$store.state.native.smphMdelName,
        bioType: "FINGERPRINT",
      };
      this.$store.dispatch("auth/manageFido/act001_manageFido", param);
    },
  },
};
</script>
